import { postDataToStore } from "../services/data";



const CreateStore = async (data) =>{
    const res = await postDataToStore(data)
    return res
}

export default CreateStore;
